<template lang="pug">
  .empty-panel
    .flex-wrap
      .info-box
        .main-info Programmes are a way to group courses into training plans.

        .check-list
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              p Assign programmes to audiences via learning groups
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              p Gather reports at top level programme level
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              p Set programmes to be dependent on training complete
        


        router-link(:to="{ name: 'itrain:programCreate' }")
                .el-button.pink GET STARTED

      .img-box
        img(src='@/assets/images/emptystates/itrain-holder.png')
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
